import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		padding: "28px 20px 30px 20px",
		width: "100%",
		boxSizing: "border-box",
		flexWrap: "wrap",
		gap: 12,
	},
}));

const MainHeader = ({ children, className = "", style = {} }) => {
	const classes = useStyles();

	return <div className={`${classes.contactsHeader} ${className}`} style={style}>{children}</div>;
};

export default MainHeader;
